import { OFFICE_CLEAR_ALL, OFFICE_UPDATE } from '../constants/offices';

export const initialState = {};

export function officeReducer( state = initialState, action ) {

    switch ( action.type ) {

        case OFFICE_UPDATE:

            return Object.assign( {}, state, action.office );

        case OFFICE_CLEAR_ALL:

            return initialState;

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/offices.js